/**
 * Error Handler Utility
 * Standardizes error logging and handling across the application
 */

import type { Logger } from 'pino'



/**
 * Safely parses JSON with error logging
 *
 * @param logger - Pino logger instance
 * @param jsonString - JSON string to parse
 * @param fallback - Fallback value if parsing fails
 * @param context - Context for logging
 * @returns Parsed object or fallback
 *
 * @example
 * ```typescript
 * const userIds = safeJsonParse(ctx.logger, jsonString, [], { field: 'user_ids' })
 * ```
 */
export function safeJsonParse<T>(
  logger: Logger,
  jsonString: string,
  fallback: T,
  context?: Record<string, unknown>
): T {
  try {
    return JSON.parse(jsonString) as T
  } catch {
    logger.warn({ ...context, jsonString }, 'Failed to parse JSON, using fallback')
    return fallback
  }
}
